import Login from '@CS/assets/Login/logo.png';
import AvatarTop from '@/assets/images/AvatarTop.png';
import AvatarLeft from '@/assets/images/AvatarLeft.png';
import AvatarBottom from '@/assets/images/AvatarBottom.png';

import Hair1 from '@/assets/images/hair/1.png';
import Hair2 from '@/assets/images/hair/2.png';
import Hair3 from '@/assets/images/hair/3.png';
import Hair4 from '@/assets/images/hair/4.png';
import Hair5 from '@/assets/images/hair/5.png';
import Hair6 from '@/assets/images/hair/6.png';
import Hair7 from '@/assets/images/hair/7.png';
import Hair8 from '@/assets/images/hair/8.png';
import Hair9 from '@/assets/images/hair/9.png';
import Hair10 from '@/assets/images/hair/10.png';
import Hair11 from '@/assets/images/hair/11.png';
import Hair12 from '@/assets/images/hair/12.png';
import Hair13 from '@/assets/images/hair/13.png';
import Hair14 from '@/assets/images/hair/14.png';
import Hair15 from '@/assets/images/hair/15.png';
import Hair16 from '@/assets/images/hair/16.png';
import Hair17 from '@/assets/images/hair/17.png';
import Hair18 from '@/assets/images/hair/18.png';
import Hair19 from '@/assets/images/hair/19.png';
import Hair20 from '@/assets/images/hair/20.png';
import Hair21 from '@/assets/images/hair/21.png';
import Hair22 from '@/assets/images/hair/22.png';
import Hair23 from '@/assets/images/hair/23.png';
import Hair24 from '@/assets/images/hair/24.png';
import Hair25 from '@/assets/images/hair/25.png';
import Hair26 from '@/assets/images/hair/26.png';
import Hair27 from '@/assets/images/hair/27.png';
import Hair28 from '@/assets/images/hair/28.png';
import Hair29 from '@/assets/images/hair/29.png';
import Hair30 from '@/assets/images/hair/30.png';
import Hair31 from '@/assets/images/hair/31.png';
import Hair32 from '@/assets/images/hair/32.png';
import Hair33 from '@/assets/images/hair/33.png';
import Hair34 from '@/assets/images/hair/34.png';
import Hair35 from '@/assets/images/hair/35.png';
import Hair36 from '@/assets/images/hair/36.png';
import Hair37 from '@/assets/images/hair/37.png';
import Hair38 from '@/assets/images/hair/38.png';
import Hair39 from '@/assets/images/hair/39.png';
import Hair40 from '@/assets/images/hair/40.png';
import Hair41 from '@/assets/images/hair/41.png';

import Face1 from '@/assets/images/face/1.png';
import Face2 from '@/assets/images/face/2.png';
import Face3 from '@/assets/images/face/3.png';
import Face4 from '@/assets/images/face/4.png';
import Face5 from '@/assets/images/face/5.png';
import Face6 from '@/assets/images/face/6.png';
import Face7 from '@/assets/images/face/7.png';
import Face8 from '@/assets/images/face/8.png';
import Face9 from '@/assets/images/face/9.png';
import Face10 from '@/assets/images/face/10.png';
import Face11 from '@/assets/images/face/11.png';
import Face12 from '@/assets/images/face/12.png';
import Face13 from '@/assets/images/face/13.png';
import Face14 from '@/assets/images/face/14.png';
import Face15 from '@/assets/images/face/15.png';
import Face16 from '@/assets/images/face/16.png';
import Face17 from '@/assets/images/face/17.png';
import Face18 from '@/assets/images/face/18.png';
import Face19 from '@/assets/images/face/19.png';
import Face20 from '@/assets/images/face/20.png';
import Face21 from '@/assets/images/face/21.png';
import Face22 from '@/assets/images/face/22.png';
import Face23 from '@/assets/images/face/23.png';
import Face24 from '@/assets/images/face/24.png';
import Face25 from '@/assets/images/face/25.png';
import Face26 from '@/assets/images/face/26.png';
import Face27 from '@/assets/images/face/27.png';
import Face28 from '@/assets/images/face/28.png';
import Face29 from '@/assets/images/face/29.png';
import Face30 from '@/assets/images/face/30.png';
import Face31 from '@/assets/images/face/31.png';
import Face32 from '@/assets/images/face/32.png';
import Face33 from '@/assets/images/face/33.png';
import Face34 from '@/assets/images/face/34.png';
import Face35 from '@/assets/images/face/35.png';
import Face36 from '@/assets/images/face/36.png';
import Face37 from '@/assets/images/face/37.png';
import Face38 from '@/assets/images/face/38.png';
import Face39 from '@/assets/images/face/39.png';
import Face40 from '@/assets/images/face/40.png';
import Face41 from '@/assets/images/face/41.png';

import Shirt1 from '@/assets/images/shirt/1.png';
import Shirt2 from '@/assets/images/shirt/2.png';
import Shirt3 from '@/assets/images/shirt/3.png';
import Shirt4 from '@/assets/images/shirt/4.png';
import Shirt5 from '@/assets/images/shirt/5.png';
import Shirt6 from '@/assets/images/shirt/6.png';
import Shirt7 from '@/assets/images/shirt/7.png';
import Shirt8 from '@/assets/images/shirt/8.png';
import Shirt9 from '@/assets/images/shirt/9.png';
import Shirt10 from '@/assets/images/shirt/10.png';
import Shirt11 from '@/assets/images/shirt/11.png';
import Shirt12 from '@/assets/images/shirt/12.png';
import Shirt13 from '@/assets/images/shirt/13.png';
import Shirt14 from '@/assets/images/shirt/14.png';
import Shirt15 from '@/assets/images/shirt/15.png';
import Shirt16 from '@/assets/images/shirt/16.png';
import Shirt17 from '@/assets/images/shirt/17.png';
import Shirt18 from '@/assets/images/shirt/18.png';
import Shirt19 from '@/assets/images/shirt/19.png';
// import Shirt20 from '@/assets/images/shirt/20.png';
import Shirt21 from '@/assets/images/shirt/21.png';
import Shirt22 from '@/assets/images/shirt/22.png';

import Pants1 from '@/assets/images/pants/1.png';
import Pants2 from '@/assets/images/pants/2.png';
import Pants3 from '@/assets/images/pants/3.png';
import Pants4 from '@/assets/images/pants/4.png';
import Pants5 from '@/assets/images/pants/5.png';
import Pants6 from '@/assets/images/pants/6.png';
import Pants7 from '@/assets/images/pants/7.png';
import Pants8 from '@/assets/images/pants/8.png';
import Pants9 from '@/assets/images/pants/9.png';
import Pants10 from '@/assets/images/pants/10.png';
import Pants11 from '@/assets/images/pants/11.png';
import Pants12 from '@/assets/images/pants/12.png';
import Pants13 from '@/assets/images/pants/13.png';
import Pants14 from '@/assets/images/pants/14.png';
import Pants15 from '@/assets/images/pants/15.png';
import Pants16 from '@/assets/images/pants/16.png';
import Pants17 from '@/assets/images/pants/17.png';
import Pants18 from '@/assets/images/pants/18.png';
import Pants19 from '@/assets/images/pants/19.png';
import Pants20 from '@/assets/images/pants/20.png';

export const Misc = {
  AvatarBottom,
  AvatarLeft,
  AvatarTop,
  Login
};

export const Hair = {
  Hair1,
  Hair2,
  Hair3,
  Hair4,
  Hair5,
  Hair6,
  Hair7,
  Hair8,
  Hair9,
  Hair10,
  Hair11,
  Hair12,
  Hair13,
  Hair14,
  Hair15,
  Hair16,
  Hair17,
  Hair18,
  Hair19,
  Hair20,
  Hair21,
  Hair22,
  Hair23,
  Hair24,
  Hair25,
  Hair26,
  Hair27,
  Hair28,
  Hair29,
  Hair30,
  Hair31,
  Hair32,
  Hair33,
  Hair34,
  Hair35,
  Hair36,
  Hair37,
  Hair38,
  Hair39,
  Hair40,
  Hair41
};

export const Face = {
  Face1,
  Face2,
  Face3,
  Face4,
  Face5,
  Face6,
  Face7,
  Face8,
  Face9,
  Face10,
  Face11,
  Face12,
  Face13,
  Face14,
  Face15,
  Face16,
  Face17,
  Face18,
  Face19,
  Face20,
  Face21,
  Face22,
  Face23,
  Face24,
  Face25,
  Face26,
  Face27,
  Face28,
  Face29,
  Face30,
  Face31,
  Face32,
  Face33,
  Face34,
  Face35,
  Face36,
  Face37,
  Face38,
  Face39,
  Face40,
  Face41
};

export const Shirt = {
  Shirt1,
  Shirt2,
  Shirt3,
  Shirt4,
  Shirt5,
  Shirt6,
  Shirt7,
  Shirt8,
  Shirt9,
  Shirt10,
  Shirt11,
  Shirt12,
  Shirt13,
  Shirt14,
  Shirt15,
  Shirt16,
  Shirt17,
  Shirt18,
  Shirt19,
  // Shirt20,
  Shirt21,
  Shirt22
};

export const Pants = {
  Pants1,
  Pants2,
  Pants3,
  Pants4,
  Pants5,
  Pants6,
  Pants7,
  Pants8,
  Pants9,
  Pants10,
  Pants11,
  Pants12,
  Pants13,
  Pants14,
  Pants15,
  Pants16,
  Pants17,
  Pants18,
  Pants19,
  Pants20
};
